type Eip1193Request = {
  method: string
  params?: unknown
}

type Eip1193Provider = {
  request: (request: Eip1193Request) => Promise<unknown>
}

type ConnectorWithProvider = {
  getProvider: () => Promise<unknown>
}

const patchedProviders = new WeakSet<Eip1193Provider>()

const isEip1193Provider = (provider: unknown): provider is Eip1193Provider =>
  typeof provider === 'object' && provider !== null && 'request' in provider && typeof provider.request === 'function'

const hasProvider = (connector: unknown): connector is ConnectorWithProvider =>
  typeof connector === 'object' &&
  connector !== null &&
  'getProvider' in connector &&
  typeof connector.getProvider === 'function'

export const normalizeEip1193ChainIdProvider = (provider: unknown) => {
  if (!isEip1193Provider(provider) || patchedProviders.has(provider)) return provider

  const request = provider.request.bind(provider)
  provider.request = async (args) => {
    const response = await request(args)
    const match = args.method === 'eth_chainId' && typeof response === 'string' ? /^eip155:(\d+)$/.exec(response) : null

    return match ? `0x${BigInt(match[1]).toString(16)}` : response
  }
  patchedProviders.add(provider)

  return provider
}

export const normalizeEip1193ChainIdConnector = async (connector: unknown) => {
  if (!hasProvider(connector)) return

  normalizeEip1193ChainIdProvider(await connector.getProvider())
}
